import * as Yup from 'yup'
import { Form, Col, Row } from 'react-bootstrap'
import { Options } from '../SelectOptions';
import { CustomFormSelect } from '../../../../StyledComponents';

export const Schema = Yup.object().shape({
    areaOfDeployment: Yup.string().required("Angabe ist erforderlich"),
});

export const AreaOfDeploymentSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId="formAreaOfDeployment">
                <Form.Label>In welchem Bereich möchtest du bei uns arbeiten?*</Form.Label>
                <CustomFormSelect
                    colors={colors}
                    name="areaOfDeployment"
                    value={values.areaOfDeployment}
                    isValid={touched.areaOfDeployment && !errors.areaOfDeployment}
                    isInvalid={touched.areaOfDeployment && errors.areaOfDeployment}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                    <option value="">Bitte auswählen...</option>
                    {Options.AreaOfDeployment.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)}
                </CustomFormSelect>
                <Form.Control.Feedback type="invalid">
                    {errors.areaOfDeployment}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};